import { render, staticRenderFns } from "./StakingLogs.vue?vue&type=template&id=12e54ee6&scoped=true&"
import script from "./StakingLogs.vue?vue&type=script&lang=js&"
export * from "./StakingLogs.vue?vue&type=script&lang=js&"
import style0 from "./StakingLogs.vue?vue&type=style&index=0&id=12e54ee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e54ee6",
  null
  
)

export default component.exports